<section class="bankList-section">
    <div class="container">
        <div class="row">
            <main id="msform">
                <div class=" col-md-12 bottom-container tablesections">
                    <div class="header-container box w-100">
                        <div class="step " id="step2">
                            <div class="col-md-12 d-flex justify-content-center mb-3 headers-headings ">
                                <span class="mobile-back-btn">
                                    <a (click)="onClickBack()"><i class='bx bx-arrow-back'></i></a>
                                </span>
                                <h3 class="section-header">Your bank account</h3>
                            </div>
                            <div class="col-md-12">
                                <div class="bank-list pb-0">
                                    <ul>
                                        <li *ngFor="let bank of bankDetails">
                                            <!-- <input class="form-check-input" type="radio" name="bank-list"
                                                id="bank-list1"> -->
                                            <label class="form-check-label" for="bank-list1">
                                                <div class="media">
                                                    <div class="media-left">
                                                        <img src="assets/img/coin/bacnk.png" alt="">
                                                    </div>
                                                    <div class="media-body">
                                                        <div class="bank-name">
                                                            {{bank.bankName}} <span *ngIf="bank.isPrimary"
                                                                class="primery-account-selected">(Primary)</span>
                                                        </div>
                                                        <div class="bank-number">
                                                            {{bank.bankAccountNumber}}
                                                        </div>
                                                    </div>
                                                    <div class="media-right">
                                                        <button *ngIf="!bank.isPrimary" (click)="onClickDelete(bank)"
                                                            class="delet-btn-div btn-danger">
                                                            <i class='bx bx-trash'></i>
                                                            <!-- <span class="mobile-none">Delete</span> -->
                                                        </button>
                                                        <button *ngIf="!bank.isPrimary" pButton
                                                            (click)="onClickSetPrimary(bank)" class="delet-btn-div">
                                                            <span class="mobile-view">Set Primary</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </label>
                                        </li>
                                    </ul>
                                    <div class="add-bank">
                                        <button id="add-bank" (click)="showbankDialog()">
                                            <span>
                                                <i class='bx bx-plus-circle'></i>
                                            </span>
                                            Add another bank account
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</section>


<p-dialog header="Add Bank Account" [(visible)]="showBankModal" [modal]="true" [style]="{ width: '500px' }"
    [draggable]="false" [resizable]="false" id="add-bank-details"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }">
    <div class="modal-body" id="msform">
        <form [formGroup]="bankForm" (ngSubmit)="onSubmitBankForm()">
            <fieldset>
                <br class="m-none-v">
                <div class="col-md-12 bankToName " style="padding: 10px;">
                    <div class="row">
                        <div class="p-field p-col-12 p-p-0">
                            <label for="bankName">
                                Bank Name
                                <span class="mandatory-fields">*</span>
                            </label>
                            <input formControlName="bankName" type="text" placeholder="Enter Bank Name" pInputText
                                class="form-control"
                                [ngClass]="{ 'is-invalid': ((bankSubmitted && bankF.bankName.errors) || (bankF.bankName.errors && (bankF.bankName.dirty || bankF.bankName.touched)))}">
                            <div *ngIf="((bankSubmitted && bankF.bankName.errors) || (bankF.bankName.errors && (bankF.bankName.dirty || bankF.bankName.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="bankF.bankName.errors.required">
                                    Bank Name is required
                                </div>
                                <div *ngIf="!bankF.bankName.errors.required">
                                    Please enter valid Bank Name
                                </div>
                            </div>
                        </div>
                        <div class="p-field p-col-12 p-p-0">
                            <label for="bankAccountNumber">Account Number
                                <span class="mandatory-fields">*</span>
                            </label>
                            <input formControlName="bankAccountNumber" placeholder="Enter Account Number" type="text"
                                pInputText class="form-control"
                                [ngClass]="{ 'is-invalid': ((bankSubmitted && bankF.bankAccountNumber.errors) || (bankF.bankAccountNumber.errors && (bankF.bankAccountNumber.dirty || bankF.bankAccountNumber.touched)))}">
                            <div *ngIf="((bankSubmitted && bankF.bankAccountNumber.errors) || (bankF.bankAccountNumber.errors && (bankF.bankAccountNumber .dirty || bankF.bankAccountNumber.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="bankF.bankAccountNumber.errors.required">
                                    Account Number is required
                                </div>
                                <div *ngIf="!bankF.bankAccountNumber.errors.required">
                                    Enter valid Account Number is required
                                </div>
                            </div>
                        </div>
                        <div class="p-field p-col-12 p-p-0">
                            <label for="confirmAccountNumber">
                                Confirm Account Number
                                <span class="mandatory-fields">*</span>
                            </label>
                            <input formControlName="confirmAccountNumber" placeholder="Enter Confirm Account Number"
                                type="password" pInputText class="form-control"
                                [ngClass]="{ 'is-invalid': ((bankSubmitted && bankF.confirmAccountNumber.errors) || (bankF.confirmAccountNumber.errors && (bankF.confirmAccountNumber.dirty || bankF.confirmAccountNumber.touched)))}">
                            <div *ngIf="((bankSubmitted && bankF.confirmAccountNumber.errors) || (bankF.confirmAccountNumber.errors && (bankF.confirmAccountNumber.dirty || bankF.confirmAccountNumber.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="bankF.confirmAccountNumber.errors.required">
                                    Confirm Account Number is required
                                </div>
                                <div *ngIf="!bankF.confirmAccountNumber.errors.required">
                                    Account Number and Confirm Account
                                    Number must be match.</div>
                            </div>
                        </div>
                        <div class="p-field p-col-12 p-p-0">
                            <label for="ifscCode">IFSC
                                <span class="mandatory-fields">*</span>
                            </label>
                            <input formControlName="ifscCode" placeholder="Enter IFSC,Eg. ABCD0123456" type="text"
                                pInputText class="form-control"
                                [ngClass]="{ 'is-invalid': ((bankSubmitted && bankF.ifscCode.errors) || (bankF.ifscCode.errors && (bankF.ifscCode.dirty || bankF.ifscCode.touched)))}">
                            <div *ngIf="((bankSubmitted && bankF.ifscCode.errors) || (bankF.ifscCode.errors && (bankF.ifscCode.dirty || bankF.ifscCode.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="bankF.ifscCode.errors.required">
                                    IFSC is required
                                </div>
                                <div *ngIf="!bankF.ifscCode.errors.required && bankF.ifscCode.errors">
                                    Invalid IFSC code
                                </div>
                            </div>
                        </div>
                        <div class="p-field p-col-12 p-p-0 mobile-numberfield">
                            <label for="phoneNumber">
                                Mobile Number
                                <span class="mandatory-fields">*</span>
                            </label>
                            <p-inputNumber placeholder="Enter Mobile Number" mode="decimal" [useGrouping]="false"
                                formControlName="mobileNumber" [maxlength]="10" class="form-control"
                                [ngClass]="{ 'is-invalid': ((bankSubmitted && bankF.mobileNumber.errors) || (bankF.mobileNumber.errors && (bankF.mobileNumber.dirty || bankF.mobileNumber.touched)))}"
                                required>
                            </p-inputNumber>
                            <div *ngIf="((bankSubmitted && bankF.mobileNumber.errors) || (bankF.mobileNumber.errors && (bankF.mobileNumber.dirty || bankF.mobileNumber.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="bankF.mobileNumber.errors.required">
                                    Mobile Number is required</div>
                                <div *ngIf="!bankF.mobileNumber.errors.required">
                                    Please enter valid 10 digit mobile
                                    number.
                                </div>
                            </div>
                        </div>
                        <div class="p-field p-col-12 p-p-0">
                            <label for="bankName">
                                Name As per bank
                                <span class="mandatory-fields">*</span>
                            </label>
                            <input formControlName="name" type="text" placeholder="Enter your Name" pInputText
                                class="form-control"
                                [ngClass]="{ 'is-invalid': ((bankSubmitted && bankF.name.errors) || (bankF.name.errors && (bankF.name.dirty || bankF.name.touched)))}">
                            <div *ngIf="((bankSubmitted && bankF.name.errors) || (bankF.name.errors && (bankF.name.dirty || bankF.name.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="bankF.name.errors.required">
                                    Name is required
                                </div>
                                <div *ngIf="!bankF.name.errors.required">
                                    Please enter valid Name
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br>
            </fieldset>
            <div class="col-md-12">
                <button type="submit" pButton>Add Bank Account</button>
            </div>
        </form>
    </div>
    <ng-template pTemplate="footer" class="modal-footer">

    </ng-template>
</p-dialog>

<p-dialog header="Delete Schedule" [(visible)]="deleteSheduleModal" [modal]="true"
    [style]="{ width: '500px',height: 'auto' }" [draggable]="false" [resizable]="false" id="delete-popup"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }">
    <ng-template pTemplate="body" class="modal-body">
        <div class="content-msg d-flex">
            <div class="icon">
                <div class="icons-div">
                    <i class="pi pi-exclamation-triangle"></i>
                </div>
                <div class="icons-body">

                    {{this.messageConfirmation}}
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer" class="modal-footer">

        <div class="footer-btn">
            <button type="button" class="cancel-btn" pButton label="Cancel"
                (click)="deleteSheduleModal = false"></button>

            <button type="button" class="delete-btn" pButton icon="pi pi-trash" label="Delete"
                (click)="onClickConfirmDelete()"></button>
        </div>

    </ng-template>
</p-dialog>
<p-toast key="toastmsg"></p-toast>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>